export const CIRCLE_WIDTH = 32
export const DEFAULT_SPLITTER_WIDTH = 20
export const DEFAULT_SPLITTER_POSITION = 50
export const MAX_SPLITTER_VAlUE = 100
export const DEFAULT_WIDTH = 1200
export const MIN_SPLITTER_VAlUE = 0
export const DEBOUNCE_MOVE_SPLITTER = 300
